import React from 'react'
import { motion } from 'framer-motion'
import ResultHero from './ResultHero'
import StrategicAlerts from './StrategicAlerts'

export default function ResultadosTabBasica({
  formStep, calculoReady, rows, rowsVista, empleadores, retroactivoEstimado,
  contextoDictamen, indicesLoading, tasaInteresTipo, setTasaInteresTipo,
  TASAS_DISPONIBLES, activeRules, modoHerramienta, setExpediente, expediente,
  escenariosLitigio, impactoTasa, serieStatus, preEmisionAudit,
  canGenerarDictamen, dictamenLoading, noPerjuicioEconomico,
  allowLitigioArtesanalBypass, contrasteNoPerjuicio, umbralConfiscatoriedadPct,
  noPerjuicioSimulationError, motivoBloqueoDictamen, onGenerarDictamen,
  formatArs, setMostrarViabilidad, registrarBypassLitigioArtesanal,
  goToStep, rowsNormativa,
}) {
  return (
    <div className="mt-4 space-y-4">
      <div className="panel-profile-accent rounded-2xl p-4">
        <p className="text-xs uppercase tracking-wide text-profile-accent">Guia de lectura</p>
        <p className="mt-1 text-sm text-slate-100">
          1) Revisa <span className="font-semibold text-profile-accent">resultado y alertas</span>. 2) Si todo está correcto, emite el informe.
          3) Usa "Ver detalle técnico" solo para auditoría profunda.
        </p>
      </div>

      {formStep >= 5 && calculoReady && rows.length > 0 && (
        <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
          {[{k:'Total Meses',v:rows.length},{k:'Empleadores',v:empleadores},{k:'Alertas de Gaps',v:rows.filter((r)=>r.requiereRevision).length},{k:'Retroactivo Estimado',v:`$${Math.round(retroactivoEstimado).toLocaleString('es-AR')}`}].map((c, i) => (
            <motion.div
              key={c.k}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.08 }}
              whileHover={{ rotateX: -3, rotateY: 3, scale: 1.01 }}
              className="rounded-xl border border-white/20 bg-white/10 p-3 shadow-[0_14px_36px_rgba(0,0,0,0.25)] backdrop-blur-2xl"
              style={{ transformStyle: 'preserve-3d' }}
            >
              <p className="text-xs text-slate-300">{c.k}</p>
              <p className="font-medium text-slate-100">{c.v}</p>
            </motion.div>
          ))}
        </div>
      )}

      {formStep >= 5 && calculoReady && rowsVista.length > 0 && (
        <div className="flex justify-start">
          <button
            type="button"
            onClick={() => goToStep(4)}
            className="rounded-xl border border-amber-300/45 bg-amber-500/15 px-4 py-2 text-sm font-semibold text-amber-100"
          >
            Volver a corregir tabla
          </button>
        </div>
      )}

      {formStep >= 5 && calculoReady && rowsVista.length > 0 && (
        <ResultHero
          haberBolsillo={contextoDictamen?.resumenEjecutivo?.haberBolsilloReajustado}
          diferencialMensual={contextoDictamen?.resumenEjecutivo?.diferencialMensual}
          retroactivoTotal={contextoDictamen?.resumenEjecutivo?.retroactivoTotal}
        />
      )}

      {formStep >= 5 && calculoReady && rowsNormativa.length > 0 && modoHerramienta === 'avanzado' && (
        <StrategicAlerts
          expediente={expediente}
          strategicRules={activeRules}
          onOpenCareModule={() => setMostrarViabilidad(true)}
        />
      )}

      {formStep >= 5 && calculoReady && rowsVista.length > 0 && modoHerramienta === 'base' && (
        <div className="panel-profile-ok rounded-2xl p-4">
          <p className="text-xs uppercase tracking-wide text-profile-ok">Resultado Simple - Calculadora Base</p>
          <div className="mt-2 grid grid-cols-1 gap-2 md:grid-cols-3">
            <div className="rounded-lg border border-white/20 bg-white/10 p-2 text-xs text-slate-100">
              <p className="text-slate-300">Haber estimado</p>
              <p className="text-base font-semibold text-profile-ok">${Math.round(Number(contextoDictamen?.resumenEjecutivo?.haberBolsilloReajustado || 0)).toLocaleString('es-AR')}</p>
            </div>
            <div className="rounded-lg border border-white/20 bg-white/10 p-2 text-xs text-slate-100">
              <p className="text-slate-300">Diferencia mensual</p>
              <p className="text-base font-semibold text-profile-accent">${Math.round(Number(contextoDictamen?.resumenEjecutivo?.diferencialMensual || 0)).toLocaleString('es-AR')}</p>
            </div>
            <div className="rounded-lg border border-white/20 bg-white/10 p-2 text-xs text-slate-100">
              <p className="text-slate-300">Retroactivo estimado</p>
              <p className="text-base font-semibold text-profile-warn">${Math.round(Number(contextoDictamen?.resumenEjecutivo?.retroactivoTotal || 0)).toLocaleString('es-AR')}</p>
            </div>
          </div>
          <p className="mt-2 text-xs text-emerald-50/90">Este resultado corresponde a estimacion base sin aplicacion de fallos judiciales. El abogado decide si avanza a estrategia litigiosa.</p>
        </div>
      )}

      {modoHerramienta === 'avanzado' && !indicesLoading && rowsVista.length > 0 && (
        <div className="rounded-2xl border border-white/20 bg-white/10 p-4 backdrop-blur-2xl">
          <div className="mb-3 flex flex-col gap-1">
            <p className="text-xs uppercase tracking-wide text-slate-300">Escenarios de Litigio</p>
            <p className="text-sm text-slate-100">Alterna índice sin recargar PDF. Cada cambio recalcula automáticamente la auditoría técnica.</p>
          </div>
          <div className="mb-3 max-w-sm">
            <label className="mb-1 block text-xs uppercase tracking-wide text-slate-300">Tasa de interés para retroactivo</label>
            <select value={tasaInteresTipo} onChange={(e) => setTasaInteresTipo(e.target.value)} className="h-10 w-full rounded-xl border border-white/20 bg-slate-900/80 px-3 text-slate-100">
              {(TASAS_DISPONIBLES || []).map((t) => <option key={t.value} value={t.value} className="bg-slate-900 text-slate-100">{t.label}</option>)}
            </select>
            <p className="mt-1 text-[11px] text-slate-300">Selecciona el precedente aplicable del expediente (A 14.290, Pinto o Cardozo) para recalcular intereses con trazabilidad.</p>
            <p className="mt-2 text-xs text-slate-300">Retroactivo estimado con tasa seleccionada: <span className="font-semibold text-profile-accent">${Math.round(retroactivoEstimado).toLocaleString('es-AR')}</span></p>
            {!serieStatus.upToDate && <p className="mt-1 text-xs text-profile-warn">Atención: tasa actualizada hasta {serieStatus.ultimaMesAnio}.</p>}
          </div>
          <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
            {escenariosLitigio.escenarios.map((esc) => {
              const activo = expediente.fallo === esc.indice
              const esMejor = escenariosLitigio.mejorIndice === esc.indice
              return (
                <button
                  key={esc.indice}
                  type="button"
                  onClick={() => setExpediente((p) => ({ ...p, fallo: esc.indice }))}
                  className={`rounded-xl border p-3 text-left transition ${activo ? 'border-cyan-300/70 bg-cyan-500/15' : 'border-white/20 bg-white/5 hover:bg-white/10'}`}
                >
                  <p className="text-xs uppercase tracking-wider text-slate-300">{esc.indice}</p>
                  <p className="mt-1 text-lg font-semibold text-slate-100">${Math.round(esc.haberInicial).toLocaleString('es-AR')}</p>
                  <p className="mt-1 text-xs text-slate-300">Haber Inicial estimado</p>
                  <p className="mt-1 text-xs text-slate-300">Retroactivo con interes: ${Math.round(esc.retroactivoConInteres).toLocaleString('es-AR')}</p>
                  {esMejor && <p className="panel-profile-ok mt-2 inline-flex rounded-full px-2 py-0.5 text-[11px] font-semibold text-profile-ok">Mas beneficioso segun jurisprudencia cargada</p>}
                </button>
              )
            })}
          </div>
          <div className="mt-3 rounded-xl border border-fuchsia-300/30 bg-fuchsia-500/10 p-3">
            <p className="text-xs uppercase tracking-wide text-fuchsia-100">Analisis de Impacto de Tasa</p>
            <p className="mt-1 text-sm text-slate-100">Retroactivo con Pasiva 14.290: <span className="font-semibold text-profile-accent">${Math.round(impactoTasa.totalPasiva).toLocaleString('es-AR')}</span></p>
            <p className="text-sm text-slate-100">Retroactivo con Tasa Activa: <span className="font-semibold text-emerald-200">${Math.round(impactoTasa.totalActiva).toLocaleString('es-AR')}</span></p>
            <p className="text-sm text-slate-100">Diferencia litigable a favor del jubilado: <span className="font-semibold text-profile-warn">${Math.round(impactoTasa.diferencia).toLocaleString('es-AR')}</span></p>
          </div>
        </div>
      )}

      {rowsVista.length > 0 && (
        <div className="panel-profile rounded-2xl p-4 backdrop-blur-2xl">
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
            <div>
              <p className="text-xs uppercase tracking-wide text-slate-300">Resumen de liquidacion</p>
              <p className="text-sm text-slate-100">Diferencial estimado: <span className="font-semibold text-profile-accent">{contextoDictamen?.estadisticas?.diferencial ?? 'N/D'}</span></p>
              <p className="mt-1 text-xs text-slate-300">Modo activo: {modoHerramienta === 'base' ? 'Calculadora Base (sin fallos)' : 'Modo Avanzado'}</p>
              <p className="mt-1 text-xs text-slate-300">Semaforo pre-emision: <span className="font-semibold text-profile-warn">{String(preEmisionAudit.color || 'verde').toUpperCase()}</span></p>
            </div>
            <button
              id="tour-legajo"
              type="button"
              onClick={onGenerarDictamen}
              disabled={!canGenerarDictamen}
              className="rounded-xl border border-cyan-200/50 bg-gradient-to-r from-cyan-300 to-blue-400 px-5 py-2.5 text-sm font-semibold text-slate-950 shadow-[0_12px_30px_rgba(56,189,248,0.35)] hover:brightness-110 disabled:cursor-not-allowed disabled:opacity-40"
            >
              {dictamenLoading
                ? 'Generando documento...'
                : (modoHerramienta === 'base' ? 'Generar Informe Base (1 Coin)' : 'Generar Dictamen (1 Coin)')}
            </button>
          </div>
          <div className="mt-3 flex flex-wrap gap-2">
            {modoHerramienta === 'avanzado' && calculoReady && noPerjuicioEconomico && (
              <div className="w-full rounded-xl border border-white/15 bg-slate-950/40 p-3 text-xs text-slate-200">
                <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-300">Matriz de contraste forense</p>
                <div className="mt-2 rounded border border-white/10 bg-white/5 p-2 text-[11px]">
                  <p>Ruta de cálculo: <span className="font-semibold text-cyan-200">{String(contextoDictamen?.diagnosticoCalculo?.scenarioKey || 'N/D')}</span></p>
                  <p>Flags activos: pension=<span className="font-semibold">{contextoDictamen?.diagnosticoCalculo?.isPensionScenario ? 'SI' : 'NO'}</span> | docente=<span className="font-semibold">{contextoDictamen?.diagnosticoCalculo?.isDocenteScenario ? 'SI' : 'NO'}</span></p>
                  <p>Haber base prestacional: <span className="font-semibold text-amber-200">{formatArs(contextoDictamen?.diagnosticoCalculo?.haberBasePrestacionalFinal || 0)}</span></p>
                  {contextoDictamen?.diagnosticoCalculo?.fallbackGeneralApplied && (
                    <p className="mt-1 text-emerald-300">Guardarraíl activo: fallback automático a fórmula general aplicado para evitar colapso de escenario especial.</p>
                  )}
                </div>
                <div className="mt-2 grid grid-cols-1 gap-2 md:grid-cols-2">
                  <div className="rounded border border-white/10 bg-white/5 p-2">
                    <p className="text-slate-300">Haber actual percibido (base expediente)</p>
                    <p className="font-semibold text-amber-200">{formatArs(contrasteNoPerjuicio.haberActual)}</p>
                  </div>
                  <div className="rounded border border-white/10 bg-white/5 p-2">
                    <p className="text-slate-300">Haber de bolsillo reajustado (simulado judicial)</p>
                    <p className="font-semibold text-cyan-200">{formatArs(contrasteNoPerjuicio.haberReajustado)}</p>
                  </div>
                  <div className="rounded border border-white/10 bg-white/5 p-2">
                    <p className="text-slate-300">Diferencia liquida</p>
                    <p className={`font-semibold ${contrasteNoPerjuicio.diferencia >= 0 ? 'text-emerald-200' : 'text-rose-200'}`}>
                      {formatArs(contrasteNoPerjuicio.diferencia)}
                    </p>
                  </div>
                  <div className="rounded border border-white/10 bg-white/5 p-2">
                    <p className="text-slate-300">Porcentaje de quita/impacto</p>
                    <p className={`font-semibold ${contrasteNoPerjuicio.impactoPct >= 0 ? 'text-emerald-200' : 'text-rose-200'}`}>
                      {Number(contrasteNoPerjuicio.impactoPct || 0).toFixed(2)}%
                    </p>
                  </div>
                </div>
                <p className="mt-2 text-[11px] text-slate-300">
                  Juicio Inviable: El perjuicio económico calculado ({formatArs(contrasteNoPerjuicio.diferencia)} / {Number(contrasteNoPerjuicio.impactoPct || 0).toFixed(2)}%) no supera el umbral de confiscatoriedad del {umbralConfiscatoriedadPct.toFixed(2)}% exigido por la jurisprudencia de la CSJN para habilitar el reajuste de topes en el Régimen General.
                </p>
                {!allowLitigioArtesanalBypass && (
                  <button
                    type="button"
                    onClick={registrarBypassLitigioArtesanal}
                    className="mt-3 rounded-lg border border-fuchsia-300/40 bg-fuchsia-500/20 px-3 py-1.5 text-xs font-semibold text-fuchsia-100"
                  >
                    Ignorar advertencia y avanzar de todos modos (Litigio Artesanal)
                  </button>
                )}
                {allowLitigioArtesanalBypass && (
                  <p className="mt-2 text-[11px] text-emerald-300">Bypass registrado en trazabilidad: estrategia de litigio artesanal habilitada para este expediente.</p>
                )}
              </div>
            )}
            {modoHerramienta === 'avanzado' && noPerjuicioSimulationError && (
              <div className="w-full rounded-xl border border-rose-300/45 bg-rose-500/15 p-3 text-xs text-rose-100">
                Error de simulación detectado: impacto negativo ({Number(contrasteNoPerjuicio.impactoPct || 0).toFixed(2)}%).
                Revisá parámetros del expediente y ruta de fórmula antes de emitir dictamen.
              </div>
            )}
            {!canGenerarDictamen && motivoBloqueoDictamen && (
              <p className="text-xs text-profile-warn">{motivoBloqueoDictamen}</p>
            )}
          </div>
        </div>
      )}
    </div>
  )
}
